import { ModalRef, useTranslation } from '@msdk/common'
import {
  ButtonPrimary,
  COLORS,
  createComponentWrapperWithRef,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  styled,
} from '@msdk/ui'
import { useEffect, useState } from 'react'

const MuiDialogContent = styled(DialogContent)`
  padding: ${(t) => t.theme.spacing(2)} ${(t) => t.theme.spacing(3)};
`

const MuiStyledDialogTitle = styled(DialogTitle)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${COLORS.grey50};
  max-height: 56px;
  padding: 16px 24px;
  border-bottom: 1px solid ${COLORS.grey50};
`

const IdleDialogTitle = createComponentWrapperWithRef(
  {
    mui: MuiStyledDialogTitle,
    nova: DialogTitle,
  },
  'IdleDialogTitle',
)

const IdleDialogContent = createComponentWrapperWithRef(
  {
    mui: MuiDialogContent,
    nova: DialogContent,
  },
  'IdleDialogContent',
)

const IdleDialogActions = createComponentWrapperWithRef(
  {
    mui: DialogActions,
    nova: DialogActions,
  },
  'IdleDialogActions',
)

interface Props {
  modalRef?: ModalRef
}

export function IdlePrompt(props: Props) {
  const t = useTranslation()
  const [timeRemaining, setTimeRemaining] = useState(120)

  useEffect(() => {
    const timeInterval = setInterval(() => {
      setTimeRemaining((prevTime) => {
        if (prevTime === 0) {
          clearInterval(timeInterval)
          return 0
        } else {
          return prevTime - 1
        }
      })
    }, 1000)

    return () => clearInterval(timeInterval)
  }, [])

  const minutes = Math.floor((timeRemaining % 3600) / 60)
    .toString()
    .padStart(2, '0')
  const seconds = (timeRemaining % 60).toString().padStart(2, '0')

  const onClick = () => {
    props.modalRef?.close()
  }

  return (
    <Dialog open={props.modalRef?.status === 'Open'}>
      <IdleDialogTitle>{t('LBL_AUTOLOGOFF_TITLE', 'Are you still here?')}</IdleDialogTitle>
      <IdleDialogContent>
        <DialogContentText>
          {t('LBL_AUTOLOGOFF_CONTENT', 'You have been inactive for a while. Do you want to continue?')}
        </DialogContentText>
      </IdleDialogContent>
      <IdleDialogActions>
        <ButtonPrimary onClick={onClick}>
          {t('LBL_AUTOLOGOFF_CONTINUE', 'Continue')} ({minutes}:{seconds})
        </ButtonPrimary>
      </IdleDialogActions>
    </Dialog>
  )
}
